import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from 'vue-router'
     import { useUserStore } from '@/stores/userStore'
     import { languageService } from '@/services/languageService'
     import { navigationService } from '@/services/navigationService'
     import { useI18n } from 'vue-i18n'
    
     
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

     const route = useRoute()
     const userStore = useUserStore()
     const { locale } = useI18n()
    
     async function loginUser() {
         try {
             const token = route.query.accessToken
             if (typeof token === 'string') {
                 await userStore.login(token)
                 locale.value = languageService.getLocale()
                 navigationService.goHomePage()
             } else {
                 navigationService.goAnonymousPage()
             }
         } catch (error) {
             console.log("User login error", error)
             navigationService.goAnonymousPage()
         }
     }
     loginUser()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})